import { Injectable } from '@angular/core';
import { IS1InputAutocompleteConfig, IS1StandardSearchModalConfig } from '@app/s1';

enum GiftcardAutocompleteAPI {
  ricerca = "/Giftcard/Ricerca",
  completamentoAutomatico = "/Giftcard/CompletamentoAutomatico"
}

interface IAutocompleteTypes {
  giftcard: IS1InputAutocompleteConfig
}

interface IStandardSearchTypes {
  giftcard: IS1StandardSearchModalConfig
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  standardSearchTypes: IStandardSearchTypes;
  autocompleteTypes: IAutocompleteTypes;

  constructor() {

    this.standardSearchTypes = {
      giftcard: { path: GiftcardAutocompleteAPI.ricerca, title: 'standardSearch.title.giftcard', hideDescription: true }
    }

    this.autocompleteTypes = {
      giftcard: { pathAutocomplete: GiftcardAutocompleteAPI.completamentoAutomatico, standardSearch: this.standardSearchTypes.giftcard }
    }

  }

}